import {
  IonButton,
  IonButtons,
  IonCardSubtitle,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonPage,
  IonRow,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import TOCItem from "./TOCItem";
import { Fragment } from "react";

const TOCModal = ({ dismiss, subject }) => {
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonTitle>View Table of Contents</IonTitle>
          <IonButtons slot="start">
            <IonButton color="main" onClick={dismiss}>
              Close
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>

      <IonContent>
        {subject && subject.units && (
          <IonGrid>
            <IonRow>
              <IonCol size="12">
                <IonCardSubtitle className="ion-text-center" color="main">
                  Table of Contents
                </IonCardSubtitle>
                {subject.units.map((unit, index) => (
                  <Fragment key={`unit_${index}`}>
                    <TOCItem name={unit.text} inset={false} />
                    {unit.chapters.map((chapter, cIndex) => (
                      <TOCItem
                        key={`chapter_${index}_${cIndex}`}
                        name={chapter.text}
                        inset={true}
                      />
                    ))}
                  </Fragment>
                ))}
              </IonCol>
            </IonRow>
          </IonGrid>
        )}
      </IonContent>
    </IonPage>
  );
};

export default TOCModal;
